import React, { PureComponent } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { ProductCardBasic } from 'appSrc/v5/components/Product';
import style from './styles/style.module.css';


class DLRichTextOutput extends PureComponent {
    convertHTMLString = ( input ) => {
        var output = ReactHtmlParser( input, {
            transform: ( node, index ) => {
                let productId, products, product;
                node.key = 'rte-output-' + index;
                if( node.type == 'tag' && node.attribs && node.attribs.class == 'exploded-product-card--placeholder' ) {
                    productId = node.attribs[ 'data-product-id' ];
                    products = this.props.products.filter( ( desire ) => ( desire.desireid == productId ) );

                    if( products.length > 0 ) {
                        product = products[ 0 ];

                        return (
                            <div className='simple-product-card' key={ 'rte-output-' + index }>
                                <ProductCardBasic product={ product } showTitle />
                            </div>
                        );
                    }
                }
                if( node.type == 'tag' && node.attribs && node.attribs.class == 'review-focused-product-card--placeholder' ) {
                    productId = node.attribs[ 'data-product-id' ];
                    products = this.props.products.filter( ( desire ) => ( desire.desireid == productId ) );

                    if( products.length > 0 ) {
                        product = products[ 0 ];

                        return (
                            <div className='simple-product-card' key={ 'rte-output-' + index }>
                                <ProductCardBasic product={ product } />
                            </div>
                        );
                    }
                }
            },
        } );
        return output;
    }


    render() {
        const content = this.convertHTMLString( this.props.content );
        const className = `ql-editor ql-output ${ style.richTextOutput } ${ this.props.className }`.trim();
        return (
            <div className={ className }
            ref={ ( el ) => { this._ref = el; } }
            onClick={ this.props.onClick }>
                { content }
            </div>
        );
    }
}
DLRichTextOutput.defaultProps = {
    className: '',
    products: [],
    content: '',
};


export default connect( null, null, null )( DLRichTextOutput );
